export const remotes = [
  {
    name: 'mfe_orders_energy',
    alias: 'mfe_orders_energy',
    entry: '/__publicPath__/mfe_orders_energy/remoteEntry.js'
  }
]

export const shared = {
  'ui-common': { requiredVersion: '1.0.0', singleton: true, eager: true }
}
